﻿let $ = window.$;
//let _dnnAppData = window.dnnAppData;
//let userInfo = this.$store.state.loggedUserInfo; // AAA!! Non funziona questo!! 

const statoUtenteRoles = Object.freeze({
    Contatto: 'Contatto',
    Cliente: 'Cliente',
  });

/*function isInRole(role)  {
    if (userInfo && userInfo.IsSuperUser)    //_dnnAppData.isSuperUser
    {
        return role != "Unverified Users";
    }

    if (role == "All Users")
    {
        return true;
    }

    if (userInfo == null && role == "Unauthenticated Users")  //_dnnAppData.userId  
    {
        return true;
    }

    if ("[" + userInfo.UserID + "]" == role) //_dnnAppData.userId
    {
        return true;
    }

    return userInfo?.Roles.some((r) => r === role) ?? false; //_dnnAppData.roles.some
}*/

/*function scrollToPosition() {
    var el = document.getElementById('preventivoSection');
    if (el != null) {
        el.scrollIntoView();
    }
}*/

/*function showLoginPopup(urlType) {

    var res = window.dnnModal.show("/Login?popUp=true&urltype=" + urlType, true / *showReturn* /, 550, 1200, true, "");
    $('iframe#iPopUp')[0].onload = function () {
        $('iframe#iPopUp')[0].contentDocument.body.style.overflow = 'scroll';
    };
 
    return res;
}*/

function initFlexSlider_SezioneVarianti() {
    $('#carouselGalleriaFotografica').flexslider({
        animation: "slide",
        controlNav: false,
        animationLoop: false,
        slideshow: false,
        itemWidth: 80 //,
        //itemMargin: 5
    });
}

function initFlexSlider_SezioneDettagli() {
    $('#carouselDettaglio').flexslider({
        animation: "slide",
        controlNav: false,
        animationLoop: false,
        slideshow: false,
        itemWidth: 80 //,
        //itemMargin: 5
    });
}

function initFlexSlider_SezioneAlternativi() {
    $('#carouselAlternativi').flexslider({
        animation: "slide",
        controlNav: false,
        animationLoop: false,
        slideshow: false,
        itemWidth: 80,
        itemMargin: 10,
        minItems: 2,
        maxItems: 10
    });
}

// function showDatiProdotto_2Caratteristiche() {
//     MakeTabellaDatiProdotto_2Caratteristiche();
//     $("#containerDatiProdotto2Caratteristiche").dialog('open');
// }

// function MakeTabellaDatiProdotto_2Caratteristiche() {
//     $("#containerDatiProdotto2Caratteristiche").dialog({
//         autoOpen: false,
//         resizable: false,
//         width: 'auto',
//         title: 'Dati prodotto',
//         buttons: {},
//         modal: true,
//         hide: { effect: 'fade', duration: 500 },
//         show: { effect: 'fade', duration: 500 },
//         open: function () { //e, ui
//             $(this).bind('keyup', function (e) {
//                 var key = window.event ? e.keyCode : e.which;
//                 if (key == 13) {
//                     $('.ui-dialog-buttonpane button:last').click();
//                 }
//             });
//         },
//         close: function () {
//             $(this).unbind('keyup');
//         }
//     });
// }

// function showZoomVideoDialog(callbackOnClose) {
//     MakeZoomVideoDialog(callbackOnClose);
//     $("#youtubePlayer").dialog('open');
// }

// function MakeZoomVideoDialog(callbackOnClose) {
//     $("#youtubePlayer").dialog({
//         autoOpen: false,
//         title: 'Dettaglio video',
//         buttons: {},
//         modal: true,
//         hide: { effect: 'fade', duration: 500 },
//         show: { effect: 'fade', duration: 500 },
//         open: function () { //e, ui
//             $(this).bind('keyup', function (e) {
//                 var key = window.event ? e.keyCode : e.which;
//                 if (key == 13) {
//                     $('.ui-dialog-buttonpane button:last').click();
//                 }
//             });
//         },
//         close: function () {
//             $(this).unbind('keyup');
//             $(this).dialog('destroy');
            
//             //callback to reset youtube component
//             callbackOnClose();
//         },
//         width: "auto"
//     });
// }

// function showZoomDialog(src) {
//     $("#ImageDettaglioZoom").attr("src", src);
//     MakeZoomDialog();
//     $("#DettaglioZoom").dialog('open');
// }

// function MakeZoomDialog() { 
//     $("#DettaglioZoom").dialog({
//         autoOpen: false,
//         title: 'Dettaglio immagini',
//         buttons: {},
//         modal: true,
//         hide: { effect: 'fade', duration: 500 },
//         show: { effect: 'fade', duration: 500 },
//         open: function () { //e, ui
//             $(this).bind('keyup', function (e) {
//                 var key = window.event ? e.keyCode : e.which;
//                 if (key == 13) {
//                     $('.ui-dialog-buttonpane button:last').click();
//                 }
//             });
//         },
//         close: function () {
//             $(this).unbind('keyup');
//             $(this).dialog('destroy');
//         },
//         width: "auto"
//     });
// }
 
// function showInfoDialog(callbackOnClose) {
//     MakeInfoDialog(callbackOnClose);
//     $("#Informazioni").dialog('open');
//     $("#Informazioni").parent().appendTo($("form:first"));
// }

// function MakeInfoDialog(callbackOnClose) { 
//     $("#Informazioni").dialog({
//         autoOpen: false,
//         resizable: false,
//         width: 'auto',
//         height: 600,
//         title: 'Disponibilità e arrivi previsti',
//         buttons: {},
//         modal: true,
//         hide: { effect: 'fade', duration: 500 },
//         show: { effect: 'fade', duration: 500 },
//         open: function () { //(e, ui)
//             $(this).bind('keyup', function (e) {
//                 var key = window.event ? e.keyCode : e.which;
//                 if (key == 13) {
//                     $('.ui-dialog-buttonpane button:last').click();
//                 }
//             });
//         },
//         close: function () {
//             $(this).unbind('keyup');

//             callbackOnClose();
//         }
//     });
// }

/*function showInfoPrezziDialog(popupTitle) {
    MakeInfoPrezziDialog(popupTitle);
    $("#infoPrezzi").dialog('open');
}

function MakeInfoPrezziDialog(popupTitle) {
    $("#infoPrezzi").dialog({
        autoOpen: false,
        resizable: false,
        width: 'auto',
        height: 600,
        title: popupTitle,
        buttons: {},
        modal: true,
        hide: { effect: 'fade', duration: 500 },
        show: { effect: 'fade', duration: 500 },
        open: function () { //e, ui
            $(this).bind('keyup', function (e) {
                var key = window.event ? e.keyCode : e.which;
                if (key == 13) {
                    $('.ui-dialog-buttonpane button:last').click();
                }
            });
        },
        close: function () {
            $(this).unbind('keyup');
        }
    });
}*/


//============= CONFIRM DIALOG =======================
//
/*function showConfirmDialog(divId, title) {

    $(divId).prop('title', title);
    MakeConfirmDialog(divId);
    $(divId).dialog('open');

    //https://stackoverflow.com/questions/757232/jquery-ui-dialog-with-asp-net-button-postback
    //utilizzare questa istruzione se all'interno del div che viene mostrato
    //come popup dal dialog di jquery si vogliono gestire eventi serverside.
    //in questo modo appendo il div alla form padre della pagina principale, 
    //e così anche tutti gli eventi
    //$(divId).parent().appendTo($("form:first"));
}

function MakeConfirmDialog(divId) {

    $(divId).dialog({
        resizable: false,
        appendTo: "#divMessagePopupPlaceholder",
        autoOpen: false,
        height: "auto",
        width: 400,
        buttons: {},
        modal: true,
        hide: { effect: 'fade', duration: 500 },
        show: { effect: 'fade', duration: 500 },
        open: function (e, ui) {
            
            $(this).bind('keyup', function (e) {
                var key = window.event ? e.keyCode : e.which;
                if (key == 13) {
                    $('.ui-dialog-buttonpane button:last').click();
                }
            });
        },
        close: function () {
            $(this).unbind('keyup');
            $(this).dialog('destroy'); //.remove();
        }
    });
}*/

function showFormRichiestaInformazioni() {

    //http://api.jqueryui.com/dialog/#option-appendTo
    //utilizzare questa option nel caso in cui ci siano pulsanti server-side che devono fare postback; 
    //inoltre vengono gestiti anche l'apertura di eventuali altri popup all'interno del popup in questione

    $("#bodyRichiestaInfoPreventivo").dialog({
        //appendTo: "#divAlternativi",  //non dovendo fare più postback, faccio l'append to alla form come gli altri popup (vedi sotto)
        resizable: false,
        autoOpen: false,
        height: "auto",
        width: 600,
        buttons: {},
        modal: true,
        hide: { effect: 'fade', duration: 500 },
        show: { effect: 'fade', duration: 500 },
        open: function () {    //(e, ui)

            $(this).bind('keyup', function (e) {
                var key = window.event ? e.keyCode : e.which;
                if (key == 13) {
                    $('.ui-dialog-buttonpane button:last').click();
                }
            });
        },
        close: function () {
            $(this).unbind('keyup');
            $(this).dialog('destroy');
        }
    });

    $("#bodyRichiestaInfoPreventivo").dialog('open');
    $("#bodyRichiestaInfoPreventivo").parent().appendTo($("form:first"));
}
 
function openPageNewTab(url) {
    window.open(url, '_blank');
}

export default{
    // scrollToPosition,
    // showLoginPopup,
    initFlexSlider_SezioneVarianti,
    initFlexSlider_SezioneDettagli,
    initFlexSlider_SezioneAlternativi,
    //showDatiProdotto_2Caratteristiche,
    //showZoomVideoDialog,
    //showZoomDialog,
    //showInfoDialog,
    //showInfoPrezziDialog,
    // showConfirmDialog,
    showFormRichiestaInformazioni,
    openPageNewTab,
    statoUtenteRoles,
    //isInRole,
}